import React from 'react';

export default function WhatsAppButton() {
  const phoneNumber = "919658375375"; // Added 91 for India
  const message = "Hi Seatify, I have a query regarding the admission process.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-24 md:bottom-6 right-4 md:right-6 z-30 group flex items-center gap-3"
      aria-label="Contact on WhatsApp"
    >
      {/* Tooltip */}
      <span className="hidden md:block bg-white text-gray-800 text-xs font-bold px-3 py-2 rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-all transform translate-x-4 group-hover:translate-x-0 pointer-events-none"
        style={{ border: '1px solid var(--card-border)' }}>
        Chat with Admissions
      </span>
      
      {/* WhatsApp Icon */}
      <div className="relative mobile-fab-safe w-12 h-12 md:w-14 md:h-14 rounded-xl md:rounded-2xl flex items-center justify-center transition-colors"
        style={{ 
          background: '#25D366',
          boxShadow: '0 10px 22px rgba(37, 211, 102, 0.22)'
        }}>
        <img
          src="/WhatsApp-full.svg"
          alt=""
          className="block w-8 h-8 md:w-9 md:h-9 object-contain"
          aria-hidden="true"
        />
      </div>
    </a>
  );
}
